import * as React from 'react';
import styled from 'styled-components';

import { iconComponents, iconSize } from './settings';
import { Props } from './types';

const IconWrapper = styled.i`
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: auto;
  flex-direction: row;
`;

export const Icon: React.FunctionComponent<Props> = ({
  color,
  size = 'md',
  name,
  onClick
}: Props) => (
  <IconWrapper onClick={onClick}>
    {React.cloneElement(iconComponents[name], {
      fill: color || 'currentColor',
      width: iconSize[size].width,
      height: iconSize[size].height
    })}
  </IconWrapper>
);
